import { render, staticRenderFns } from "./AppsIndex.vue?vue&type=template&id=a5094de4&"
import script from "./AppsIndex.vue?vue&type=script&lang=js&"
export * from "./AppsIndex.vue?vue&type=script&lang=js&"
import style0 from "./AppsIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports